/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ContractRegistry,
  ContractRegistryInterface,
} from "../ContractRegistry";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "ContractRegistryInvalidContract",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "nameHash",
        type: "bytes32",
      },
    ],
    name: "ContractRegistryNotRegistered",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "nameHash",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "RegisteredContract",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "whitelisted",
        type: "bool",
      },
    ],
    name: "WhitelistedToken",
    type: "event",
  },
  {
    inputs: [],
    name: "allWhitelistedTokens",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "nameHash",
        type: "bytes32",
      },
    ],
    name: "getRegisteredContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "isWhitelistedToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "nameHash",
        type: "bytes32",
      },
    ],
    name: "removeRegisteredContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "removeWhitelistedToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "nameHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "setRegisteredContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "setWhitelistedToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class ContractRegistry__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ContractRegistry> {
    return super.deploy(overrides || {}) as Promise<ContractRegistry>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ContractRegistry {
    return super.attach(address) as ContractRegistry;
  }
  connect(signer: Signer): ContractRegistry__factory {
    return super.connect(signer) as ContractRegistry__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ContractRegistryInterface {
    return new utils.Interface(_abi) as ContractRegistryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ContractRegistry {
    return new Contract(address, _abi, signerOrProvider) as ContractRegistry;
  }
}
